import { displayMessage } from "../../../../../helpers/messages";


export default [
    {
        field: 'id',
        headerName: displayMessage('ID'),
        width: 100,
    },
    {
        field: 'title',
        headerName: displayMessage('TITLE'),
        width: 300,
    },
    {
        field: 'type_description',
        headerName: displayMessage('TYPE'),
        width: 200,
    },
    {
        field: 'category',
        headerName: displayMessage('CATEGORY'),
        width: 200,
        valueGetter: (params) => params.row?.Category?.description,
    },
    {
        field: 'subcategory',
        headerName: displayMessage('SUBCATEGORY'),
        width: 200,
        valueGetter: (params) => params.row?.SubCategory?.description ? params.row?.SubCategory?.description : "N/A",
    },
    {
        field: 'type_description',
        headerName: displayMessage('TYPE'),
        width: 200,
    },
    {
        field: 'order_code',
        headerName: displayMessage('ORDER_CODE'),
        width: 80,
    },
    {
        field: 'description',
        headerName: displayMessage('DESCRIPTION'),
        flex: 1,
    },
   
   
]